export const INPUT_TYPE = [
    {
      type: 'text',
      show: 'TEXT',
    },
    {
      type: 'rating',
      show: 'RATING',
    },
    {
      type: 'yesnot',
      show: 'YES_NOT',
    },
    {
      type: 'rating_a',
      show: 'RATING_A',
    },
  ];

export const DEFAULT_MODELS = [
  {
    "id": 22,
    "account_id": 1,
    "name": "NPS",
    "description": "NPS com logic",
    "questions": [
        {
            "question": "De 0 a 10 qual a probabilidade de você indicar a nossa empresa para um amigo ou colega?",
            "type": "rating_a",
            "required": false
        }
    ],
    "uuid": "1d0b90a1-30c6-431d-892f-fbbc2d3b17c2",
    "logo": "",
    "redirect": false,
    "redirect_url": "",
    "is_fixed": true,
    "message": "Queremos melhorar nossa empresa com sua ajuda.",
    "thank_message": "Obrigado, seu feedback é muito importante.",
    "good_message": "Ótimo! O que tornou sua experiência tão positiva?",
    "neutral_message": "O que podemos fazer melhor? Seu feedback ajudará a realizar melhorias.",
    "bad_message": "Lamentamos saber que sua experiência não foi positiva. Conte-nos como podemos melhorar."
}
]
